export async function microsoftPopup(
  startUrl: string,
  destination: "admin" | "pro",
  exchange: (code: string, verifier: string) => Promise<void>
): Promise<void> {
  const popup = window.open("about:blank", "_blank", "popup,width=520,height=720");
  if (!popup) throw new Error("Tillad pop op-vinduer for at logge ind med Microsoft.");

  try {
    const bytes = crypto.getRandomValues(new Uint8Array(32));
    const verifier = Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
    const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(verifier));
    const challenge = btoa(String.fromCharCode(...Array.from(new Uint8Array(digest))))
      .replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
    const url = new URL(startUrl);
    url.searchParams.set("destination", destination);
    url.searchParams.set("challenge", challenge);

    await new Promise<void>((resolve, reject) => {
      let exchanging = false;
      const cleanup = () => {
        window.removeEventListener("message", receive);
        window.clearInterval(closed);
        window.clearTimeout(timeout);
      };
      const receive = async (event: MessageEvent) => {
        if (event.origin !== url.origin || event.source !== popup || exchanging) return;
        if (event.data?.type !== "entra-login" || typeof event.data.code !== "string") return;
        exchanging = true;
        cleanup();
        try {
          await exchange(event.data.code, verifier);
          resolve();
        } catch (error) {
          reject(error);
        } finally {
          popup.close();
        }
      };
      const closed = window.setInterval(() => {
        if (!popup.closed) return;
        cleanup();
        reject(new Error("Microsoft login blev lukket. Prøv igen."));
      }, 500);
      const timeout = window.setTimeout(() => {
        cleanup();
        popup.close();
        reject(new Error("Microsoft login udløb. Prøv igen."));
      }, 10 * 60 * 1000);
      window.addEventListener("message", receive);
      popup.location.href = url.toString();
    });
  } catch (error) {
    popup.close();
    throw error;
  }
}
